import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

function RosaMkt() {
  const userEmail = sessionStorage.getItem("userEmail");
  const navigate = useNavigate();

  useEffect(() => {
    if (!userEmail) navigate("/signin");
  }, [userEmail, navigate]);

  const openInbox = () => {
    const gmailUrl = `https://mail.google.com/mail/?authuser=${encodeURIComponent(userEmail)}`;
    window.open(gmailUrl, "_blank", "noopener,noreferrer");
  };

  const openUnread = () => {
    navigate("/unread-mails");
  };

  return (
    <div style={styles.page}>

      <div style={styles.card}>

        <h2 style={styles.title}>Rosa Mkt</h2>

        <p style={styles.email}>
          Signed in as <b>{userEmail}</b>
        </p>

        <button style={styles.button} onClick={openInbox}>
          Inbox
        </button>

        <button style={styles.button} onClick={openUnread}>
          Unread Mails
        </button>

      </div>

    </div>
  );
}

const styles = {

  page: {
    height: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#f4f6f8"
  },

  card: {
    background: "white",
    padding: "40px",
    borderRadius: "10px",
    boxShadow: "0px 6px 18px rgba(0,0,0,0.1)",
    textAlign: "center",
    width: "320px"
  },

  title: {
    marginBottom: "15px"
  },

  email: {
    marginBottom: "25px",
    color: "#444"
  },

  button: {
    width: "100%",
    height: "50px",
    marginTop: "15px",
    fontSize: "16px",
    backgroundColor: "#1976d2",
    color: "white",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer"
  }

};

export default RosaMkt;